module.exports = __webpack_public_path__ + "media/images/solution-cards-dark-1b9188835316c23966009b92694f7e18.png";